module.exports = __webpack_public_path__ + "static/redux-4912f6d800e1b75354e0b5d4794e1856.png";